module.exports = __webpack_public_path__ + "static/brasil-634991b598380e16a7a57835d48d4f39.webp";